import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import styled from "styled-components";
import GradientButton from "../GradientButton";
import FilterOption from "../Marketplace/FilterOption";

const StyledMobileMarketFilter = styled.dialog`
  height: 40vh;
  width: 90vw;
  border-radius: 34px;
  background: rgba(46, 46, 46, 0.56);
  backdrop-filter: blur(0.5rem);
  display: none;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 25px;
  border-style: solid;
  border-width: 0px;

  &[open] {
    display: flex;
  }

  #title {
    color: #ffffff;
    font-size: 30px;
    margin: 0px;
  }

  .filter-option-radio {
      padding: 10px 20px 10px 20px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
`;

const MobileMarketFilter = forwardRef(function MobileMarketFilter(
  { onFilterChanged },
  ref
) {
  const modalRef = useRef();

  const [selectedCategories, setSelectedCategories] = useState([]);

  function onCategorySelect(category) {
    //adding or removing the category
    if (selectedCategories.includes(category)) {
      setSelectedCategories([
        ...selectedCategories.filter((element) => element != category),
      ]);
    } else {
      setSelectedCategories([...selectedCategories, category]);
    }
  }

  function onApplyFilters() {
    modalRef.current.close();
    onFilterChanged(selectedCategories);
  }

  function onClearAll() {
    onFilterChanged([]);
  }

  useImperativeHandle(ref, () => {
    return {
      open: open,
      close: close,
    };
  });

  function close() {
    modalRef.current.close();
  }

  function open() {
    modalRef.current.showModal();
  }

  return (
    <StyledMobileMarketFilter ref={modalRef}>
      <p id="title">Filters</p>
      <div className="filter-option-radio">
        <FilterOption
          onSelect={() =>
            onCategorySelect("0x2bcbb73c73d765a695f972bdd84222ee8ee55f2d")
          }
          isSelected={selectedCategories.includes(
            "0x2bcbb73c73d765a695f972bdd84222ee8ee55f2d"
          )}
          optionText={"Qorbs"}
        ></FilterOption>
      </div>
      <div className="filter-option-radio">
        <FilterOption
          onSelect={() =>
            onCategorySelect("0xcd05e79857c1c0eb1eeaf1573a12c25d411e0757")
          }
          isSelected={selectedCategories.includes(
            "0xcd05e79857c1c0eb1eeaf1573a12c25d411e0757"
          )}
          optionText={"QorX Pass"}
        ></FilterOption>
      </div>
      <div className="filter-option-radio">
        <FilterOption
          onSelect={() =>
            onCategorySelect("0xb1dbf0fc711f268b3a3755f8171a9269d6d105fd")
          }
          isSelected={selectedCategories.includes(
            "0xb1dbf0fc711f268b3a3755f8171a9269d6d105fd"
          )}
          optionText={"Skins"}
        ></FilterOption>
      </div>
      <div className="filter-option-radio">
        <FilterOption
          onSelect={() =>
            onCategorySelect("0x7a6d3fb14a2eefd8173584a96abd2fafa08e396a")
          }
          optionText={"Pets"}
          isSelected={selectedCategories.includes(
            "0x7a6d3fb14a2eefd8173584a96abd2fafa08e396a"
          )}
        ></FilterOption>
      </div>
      <GradientButton text={"Apply"} onTap={onApplyFilters}></GradientButton>
    </StyledMobileMarketFilter>
  );
});

export default MobileMarketFilter;
